import { FC } from 'react';
import PermissionDeniedPage from '../Security/PermissionDeniedPage';

const EventPermissionDeniedPage: FC = () => (
  <PermissionDeniedPage
    title="Kein Zugriff auf dieses Event"
    description="Du hast aktuell nicht die notwendige Berechtigung, um dieses Event zu sehen. Bitte wende Dich an Deine Managerin oder Deinen Manager, wenn Du Zugriff benötigst."
    buttonLabel="Zurück zu den Events"
  />
);

export default EventPermissionDeniedPage;
